/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ViewEdgesIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="ViewEdgesIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M2 3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V8H13V3L3 3V13H6.5V14H3C2.44772 14 2 13.5523 2 13V3Z"
                fill="currentColor"
              />
              <path d="M9 15V8L14 13H11L9 15Z" fill="currentColor" />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

ViewEdgesIcon.tags = [
  'box',
  'square',
  'arrow',
  'show',
  'expand',
  'enlarge',
  'focus',
  'resize',
];

ViewEdgesIcon.category = 'General Icons';

ViewEdgesIcon.iconSize = 16;
